export const PAGE_LiMIT = 10

export const languages = [
  'ru',
  'uk',
  'en',
  'pl',
  'cs',
  'de',
  'es',
  'fr',
  'it',
  'ch',
  'hi',
  'ja',
  'ko',
  'tr',
  'gr',
  'kt',
  'sv',
  'sk',
  'th',
  'hr',
  'fi',
  'sl',
  'nl',
]
